"use strict";
import {on, find, findAllIn, findIn, empty} from '../libs/@elements/dom-utils';
import {onFind} from "../libs/@elements/init-modules-in-scope";
import asyncAppend from "../libs/@elements/async-append";
import fetch from '../libs/@elements/fetch';
import Modal from 'bootstrap/js/dist/modal';

export function init () {
    onFind('.js-fetch-modal-toggle', function (element) {
        let modal = find(element.getAttribute('data-target'));
        let modalInit = new Modal(modal);

        on('click', function () {
            let url = element.getAttribute('data-content-url');

            modalInit.show();

            asyncAppend({
                target: findAllIn('.js-fetch-modal__content', modal),
                loading: findAllIn('.js-fetch-modal__loading', modal)
            }, fetch(url));
        }, element);

        on('hidden.bs.modal', function () {
            empty(findIn('.js-ajax-modal__content', modal));
        }, modal);
    });
}